import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { REMINDER_TYPES, PRIORITY_OPTIONS } from '../constants';

export const ReminderDialog = ({ 
  open, 
  onOpenChange, 
  leadId,
  newReminder, 
  setNewReminder, 
  onSubmit 
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => onOpenChange({ open: o, leadId: o ? leadId : null })}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Reminder</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Reminder Type</Label>
            <Select value={newReminder.reminder_type} onValueChange={(v) => setNewReminder({...newReminder, reminder_type: v})}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {REMINDER_TYPES.map(t => (
                  <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Title *</Label>
            <Input 
              value={newReminder.title}
              onChange={(e) => setNewReminder({...newReminder, title: e.target.value})}
              placeholder="e.g., Follow up call"
            />
          </div>
          <div className="space-y-2">
            <Label>Due Date *</Label>
            <Input 
              type="datetime-local"
              value={newReminder.due_date}
              onChange={(e) => setNewReminder({...newReminder, due_date: e.target.value})}
            />
          </div>
          <div className="space-y-2">
            <Label>Priority</Label>
            <Select value={newReminder.priority} onValueChange={(v) => setNewReminder({...newReminder, priority: v})}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {PRIORITY_OPTIONS.map(p => (
                  <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea 
              value={newReminder.description}
              onChange={(e) => setNewReminder({...newReminder, description: e.target.value})}
              placeholder="Additional notes..."
              rows={2}
            />
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange({ open: false, leadId: null })}>Cancel</Button>
          <Button onClick={onSubmit}>Create Reminder</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
